import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box } from '@mui/material';

import Delete from '../../../../../assets/icons/Delete.svg';
import Button, { BUTTON_VARIANT } from '../../../../../components/Button';

import BasicDrawer from './BasicDrawer';
import DeletedPlacementCard from './DeletedPlacementCard';

const DeletePlacementDrawer = ({
  isOpen,
  onClose,
  candidateName,
  handleCancelPlacement,
  isOneOpening = true,
  isAdmin = false,
}) => {
  const headerText = LanguageConverterV2('jobOrder.roster.headerTextForRemoveEmployee');
  const skipNotifications = true;

  const subHeaderText = LanguageConverterV2(
    isOneOpening
      ? 'jobOrder.roster.subHeaderTextForRemoveEmployee.oneOpening'
      : 'jobOrder.roster.subHeaderTextForRemoveEmployee.entireSeries'
  );
  const HeaderIcon = () => (
    <Box
      component="img"
      sx={{
        height: 51.52,
        width: 51.52,
      }}
      alt="Delete"
      src={Delete}
    />
  );

  const GoBackButton = () => (
    <Button
      variant={BUTTON_VARIANT.OUTLINED}
      onClick={onClose}
      text={LanguageConverterV2('button.goBack')}
    />
  );

  const RemoveButton = () => (
    <Button
      variant={BUTTON_VARIANT.DELETE}
      onClick={() => handleCancelPlacement()}
      sx={{ marginLeft: '5px' }}
      text={LanguageConverterV2('button.employee.remove')}
    />
  );
  const RemoveWithoutNotificationsButton = () => (
    <Button
      variant={BUTTON_VARIANT.DELETE}
      onClick={() => handleCancelPlacement(skipNotifications)}
      text={LanguageConverterV2('button.employee.removeWithoutNotifications')}
    />
  );

  const ActionButtons = () => (
    <Box sx={{ display: 'flex', gap: '5px' }}>
      <RemoveButton />
      {isAdmin && <RemoveWithoutNotificationsButton />}
    </Box>
  );

  return (
    <BasicDrawer
      goBackButton={<GoBackButton />}
      actionButton={<ActionButtons />}
      headerIcon={<HeaderIcon /> || null}
      header={headerText}
      subHeader={subHeaderText}
      content={<DeletedPlacementCard name={candidateName} />}
      onClose={onClose}
      isOpen={isOpen}
    />
  );
};

DeletePlacementDrawer.propTypes = {
  candidateName: PropTypes.string,
  handleCancelPlacement: PropTypes.func,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  isOneOpening: PropTypes.bool,
  isAdmin: PropTypes.bool,
};

export default DeletePlacementDrawer;
